import React from "react";
import { CustomDiv } from "../../../chat-bot/style";
import CreateEnrich from "../../sow-enrichment/components/CreateEnrich";
import { useLocation } from "react-router-dom";

export default function SowDraft() {
  const query = new URLSearchParams(useLocation().search);
  const id = query.get("id");
  return (
    <CustomDiv>
      <CreateEnrich sowId={id} />
    </CustomDiv>
  );
}
